export const FETCH_ROUTES = 'routes/Routes/FETCH_ROUTES'
export const FETCH_ROUTES_SUCCESS = 'routes/Routes/FETCH_ROUTES_SUCCESS'
export const FETCH_ROUTES_ERROR = 'routes/Routes/FETCH_ROUTES_ERROR'
export const SELECT_ROUTE = 'routes/Routes/SELECT_ROUTE'
export const SET_ROUTES_STATE = 'routes/Routes/SET_ROUTES_STATE'
